<template>
  <TheG01Content
    :categories="categories"
    class="p-the-g01-content-category"
    :is-category="true"
  >
    <div class="p-the-g01-content-category__list">
      <template v-for="(category, key) in categories">
        <G01ItemListGroup
          v-if="category.sku_set.length > 0"
          :key="key"
          :category-id="category.category_id"
          :category-label="category.category_name"
          :items="category.sku_set"
          :is-category="true"
          class="p-the-g01-content-category__list__item"
        />
      </template>
    </div>
  </TheG01Content>
</template>

<script lang="ts">
import TheG01Content from "@/general/components/pages/parts/Ranking/TheG01Content.vue";
import G01ItemListGroup from "@/general/components/pages/parts/Ranking/G01ItemListGroup.vue";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";
import items from "@/general/store/modules/items";
import { rankingByCategory } from "@/general/store/api";

@Options({
  components: {
    TheG01Content,
    G01ItemListGroup
  }
})
export default class TheG01ContentCategory extends Vue {
  rankingCategory: any = [];

  get categories() {
    return this.rankingCategory;
  }
  async created() {
    this.rankingCategory = await rankingByCategory();
  }
}
</script>

<style lang="scss" scoped>
.p-the-g01-content-category {
  &__list {
    &__item {
      margin-top: rem(24);

      @include large-sp {
        &:first-of-type {
          border-top: px(1) solid $common-gray-border;
        }
      }
    }
  }
}
</style>
